import React, { useRef, useState, useEffect } from "react";
import '../assets/OurProjects.css';
import home from '../assets/imgs/home.webp';
import hand from '../assets/events/hand.webp';
import hologram from '../assets/events/hologram-of-house.webp';
import pone from '../assets/imgs/our-project.webp';
import swaraj from '../assets/imgs/swaraj-toran.webp';
import lonavalley from '../assets/imgs/lonavalley-3.webp';
import kokan from '../assets/imgs/kokan.webp';
import hinjewadi from '../assets/imgs/hinjewadi.webp';
import kirkatwadi from '../assets/imgs/kirkatwadi.jpg';
import dhayari from '../assets/imgs/dhayari-flats.jpeg';
import riviera from '../assets/imgs/riviera.webp';

const cardData = [
    {
        img: kirkatwadi,
        title: "",
        units: "Premium 1BHK",
        address: "Kirkatwadi Pune"
    },
    {
        img: dhayari,
        title: "",
        units: "Premium 1BHK & 2BHK",
        address: "Dhayari Pune"
    },
     {
        img: riviera,
        title: "Dam view Farmhouse PLots",
        units: "50 Acres",
        address: "Velhe, pune"
    },
    {
        img: pone,
        title: "Water View/Touch Farmhouse Plots ",
        units: "100+ Acres",
        address: "Pune, Panshet Backwaters"
    },

    {
        img: lonavalley,
        title: "@Lonavala Annexe Resort NA Plots",
        units: "108 Acres",
        address: "@Lonavala Annexe"
    },
    {
        img: hinjewadi,
        title: "Farmhouse, NA, Bungalow Plots",
        units: "118 Acres",
        address: "@Hinjewadi Annexe, Pune"
    },
   


];

export default function OurProjects() {
    const [activeIndex, setActiveIndex] = useState(0);
    const cardContainerRef = useRef(null);
    const [cardWidth, setCardWidth] = useState(220);

    // Handle swipe (desktop arrows)
    const handleSwipe = (direction) => {
        if (direction === "left") {
            setActiveIndex((prev) => (prev + 1) % cardData.length);
        } else {
            setActiveIndex((prev) => (prev - 1 + cardData.length) % cardData.length);
        }
    };

    // Update card width on resize
    useEffect(() => {
        const updateCardWidth = () => {
            if (cardContainerRef.current) {
                const card = cardContainerRef.current.querySelector(".op-card");
                if (card) setCardWidth(card.offsetWidth + 20); // add margin
            }
        };

        updateCardWidth();
        window.addEventListener("resize", updateCardWidth);
        return () => window.removeEventListener("resize", updateCardWidth);
    }, []);

    // Touch swipe logic
    useEffect(() => {
        let startX = 0;
        let endX = 0;

        const handleTouchStart = (e) => {
            startX = e.touches[0].clientX;
        };

        const handleTouchMove = (e) => {
            endX = e.touches[0].clientX;
        };

        const handleTouchEnd = () => {
            const delta = startX - endX;
            if (delta > 50) {
                handleSwipe("left");
            } else if (delta < -50) {
                handleSwipe("right");
            }
        };

        const container = cardContainerRef.current;
        if (container) {
            container.addEventListener("touchstart", handleTouchStart);
            container.addEventListener("touchmove", handleTouchMove);
            container.addEventListener("touchend", handleTouchEnd);
        }

        return () => {
            if (container) {
                container.removeEventListener("touchstart", handleTouchStart);
                container.removeEventListener("touchmove", handleTouchMove);
                container.removeEventListener("touchend", handleTouchEnd);
            }
        };
    }, []);

    const activeCard = cardData[activeIndex];

    return (
        <div className="op-outer-container">
            <div className="op-container">
                <div className="op-info-section">
                    <div className="op-house-icon">
                        <img src={hologram} loading="lazy" alt="icon" />
                    </div>
                    <div className="op-inner-text">
                        <div className="op-unit-text">{activeCard.units}</div>
                        <div className="op-address">{activeCard.address}</div>
                    </div>
                    <div className="op-hand">
                        <img src={hand} loading="lazy" alt="hand" />
                    </div>
                </div>

                <div className="op-carousel">
                    <button className="op-arrow left" onClick={() => handleSwipe("right")}>❮</button>

                    <div
                        ref={cardContainerRef}
                        className="op-card-container"
                        style={{
                            transform: `translateX(-${activeIndex * cardWidth}px)`,
                            transition: 'transform 0.6s ease-in-out',
                        }}
                    >
                        {cardData.map((card, index) => (
                            <div
                                key={index}
                                className={`op-card ${index === activeIndex ? "active" : "inactive"}`}
                            >
                                <img src={card.img} loading="lazy" alt={card.title} />
                                <div className="op-deal-title">{card.title}</div>
                            </div>
                        ))}
                    </div>

                    <button className="op-arrow right" onClick={() => handleSwipe("left")}>❯</button>
                </div>
            </div>
            <div className="op-tagline">The Smart Investor’s Address</div>
        </div>
    );
}
